import React from 'react'

import { ButtonLink } from '../utils/Button'
import Card from '../utils/Card'

const PremiumMember = () => {
  return (
    <Card className="mt-4">
      <div className="flex items-center mb-4">
        <div className="prose prose-lg">
          <h3 className="inline md:hidden lg:inline ">Premium Members, you are the best!</h3>
          <h3 className="hidden md:inline lg:hidden">Premium Members, you are the best!</h3>
        </div>
      </div>
      <div>
        <div className="prose prose-lg">
          <p>
            Hey there Premium member! We noticed that you’ve been using our service for over a year and it would make us
            so happy if you renewed your membership.
          </p>
          <p>
            Finding great campsites for you is our passion, and to make that happen we rely on campers like you to
            support our service.
          </p>
        </div>
        <div className="mt-3">
          <ButtonLink to="/premium/renew" color="darkGreen" className="w-full">
            Renew My Premium Account
          </ButtonLink>
        </div>
      </div>
    </Card>
  )
}

export default PremiumMember
